import React from 'react';
import { Container, Table, Title } from './styled';
import style from '../../../../../routes/score/baseball/match/lineup/batterTable/style.module.scss';
import OutImage from 'images/sports/common/out.png';
import InImage from 'images/sports/common/in.png';
import { observer } from 'mobx-react';

const BatterTable = observer(({ data }) => {
  return (
    <Container>
      <Title>타자</Title>
      <Table>
        <thead>
          <tr>
            <th>타순</th>
            <th>선수명</th>
            <th>타율</th>
            <th>포지션</th>
          </tr>
        </thead>
        <tbody>
          {data.map((value, key) => {
            const {
              name,
              battingSlot,
              battingAverage,
              position,
              slotIndex,
              startingMember
            } = value;
            const dataLength = data.length;
            const nextIdx = key + 1;
            let activeIcon = false;
            let lastIn = false;

            if (
              dataLength > nextIdx &&
              battingSlot === data[key + 1].battingSlot
            ) {
              activeIcon = true;
            }

            if (
              key > 0 &&
              dataLength > nextIdx &&
              battingSlot === data[key - 1].battingSlot
            ) {
              activeIcon = true;

              if (slotIndex < data[key - 1].slotIndex) {
                lastIn = true;
              }
            }
            return (
              <tr key={key}>
                <td className={style.battingSlot}>
                  {battingSlot}
                  {activeIcon && (
                    <img src={lastIn ? OutImage : InImage} alt="out" />
                  )}
                </td>
                <td className={style.player}>{name}</td>
                <td className={style.battingAverage}>{battingAverage}</td>
                <td className={style.position}>{position}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );
});

export default BatterTable;
